"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PatternBaseGLFilter = _interopRequireDefault(require("./PatternBaseGLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class PatternEightFoldReflectedGLFilter extends _PatternBaseGLFilter.default {
  constructor() {
    const fsSource = `
        precision mediump float;

        uniform sampler2D t_tex;
        varying highp vec2 v_uv;
        uniform float zoom;
        uniform float aspect;
        uniform bool greyScale;
        uniform float greyLevels;
        uniform float blackWhiteThreshold;  //black to white boundary range -1.0 - 1.0

        void main(void)
        {
            const float segments = 8.;
            const float pi = 3.1415926535;
            const float segmentAngle = 2. * pi / segments;

            vec2 p = zoom * (v_uv - vec2(0.5, 0.5));

            //Correct for different aspect ratios of GL surface
            if(aspect >= 1.)
                p.x = p.x * aspect;
            else
                p.y = p.y / aspect;

            const float width = 1.;

            // diamond pattern
            vec2 pt;
            const float s2 = 1.0/sqrt(2.0);

            // rotate by 45 degrees
            pt.x = p.x * s2 - p.y * s2;
            pt.y = p.x * s2 + p.y * s2;

            // do fraction - fract doesn't like negative numbers!
            pt.x = pt.x - mod ( pt.x, width );
            pt.y = pt.y - mod ( pt.y, width );

            // rotate back
            vec2 pc;
            pc.x = pt.x * s2 + pt.y * s2 + s2 * width; // center to origin also
            pc.y = pt.x * -s2 + pt.y * s2;

            // now we can use pc to round our original point
            vec2 ph = p - pc;

            // cartesian to polar coordinates
            float r = length(ph);
            float theta = atan(ph.y, ph.x);

            // figure out which segment you're in
            // angles are from -pi to +pi
            float region = segments * (theta + pi) / (2. * pi);
            float k = fract(region) * segmentAngle;

            // flip alternate segments
            float intRegion = region - fract(region);
            if(mod(intRegion, 2.) == 0.)
            {
                k = segmentAngle - k;
            }

            // polar to cartesian coordinates
            p = r * vec2(cos(k), sin(k));

            if(greyScale == true) {
                vec4 texColor = texture2D(t_tex, p * 1.7 + .1);
                int bitGrey = int((0.21 * texColor.x + 0.72 * texColor.y + 0.07 * texColor.z) * greyLevels + blackWhiteThreshold);
                float grey = (float(bitGrey) / (greyLevels - 1.));
                gl_FragColor = vec4(grey, grey, grey, 1.0);
            }
            else {
                gl_FragColor = texture2D(t_tex, p * 1.7 + .1);
            }

            //debugging!
            //gl_FragColor = vec4(k / 6., 0., 0., 1.);
        }
        `;
    super(fsSource);
  }

}

exports.default = PatternEightFoldReflectedGLFilter;